<template>
  <div class=" pannel-container">
    <div class="pannel-header" style="display:flex; align-items:center; justify-content:space-between;">
      <h2
        style="color: #171725;
                font-size: 20px;
                font-weight: 600;
                letter-spacing: 0.1px;
                margin-left: -4px;
                "
      >
        Realtime Overview
      </h2>

      <!-- Countdown circular timer: outer ring shows remaining progress, inner shows seconds -->
      <div class="countdown" role="timer" :aria-label="`Countdown ${remainingSecondsDisplay} seconds`">
        <svg viewBox="0 0 64 64" class="countdown-svg">
          <circle class="countdown-bg" cx="32" cy="32" r="26" fill="none" stroke="#e6e6e6" stroke-width="6" />
          <circle
            class="countdown-fg"
            cx="32"
            cy="32"
            r="26"
            fill="none"
            stroke="#101F4A"
            stroke-width="6"
            :style="{ strokeDasharray: circleCircumference + 'px', strokeDashoffset: strokeDashoffset + 'px' }"
            stroke-linecap="round"
            transform="rotate(-90 32 32)"
          />
        </svg>
        <div class="countdown-label">{{ remainingSecondsDisplay }}</div>
      </div>
    </div>
    <div style=" margin: 4px -4px; font-weight: 500;">{{ formattedTime }}</div>
    <v-row>
      <v-col cols="6" class="col-pannel">
        <v-card class="pa-3">
          <div style=" display: flex; justify-content: space-between;">
            <div class="label-data">
              Total Sales
            </div>
            <v-icon style=" color: #171725;">mdi-cash-multiple</v-icon>
          </div>
          <div class="value-data">
            {{ formatPrice(totalSales) }}
          </div>
        </v-card>
      </v-col>

      <v-col cols="6" class="col-pannel">
        <v-card class="pa-3">
          <div style=" display: flex; justify-content: space-between;">
            <div class="label-data">Total Orders</div>
            <v-icon style=" color: #171725;">mdi-account-cash-outline</v-icon>
          </div>
          <div class="value-data">{{ totalOrders }}</div>
        </v-card>
      </v-col>

      <!-- <v-col cols="6" class="col-pannel">
        <v-card class="pa-3">
          <div class="label-data">
            CR
          </div>
          <div class="value-data">{{ conversionRate }}%</div>
        </v-card>
      </v-col>

      <v-col cols="6" class="col-pannel">
        <v-card class="pa-3">
          <div class="label-data">AOV</div>
          <div class="value-data">{{ formatPrice(aov) }}</div>
        </v-card>
      </v-col> -->
    </v-row>

    <v-row>
      <v-col class="col-pannel">
        <v-card class="pa-3">
          <v-row>
            <v-col cols="6" class="col-pannel">
              <div class="label-data" style="padding-left: 8px;">Active users in last 30 minutes</div>
              <div class="value-data" style="padding-left: 8px;">{{ realtimeOverview.total }}</div>
            </v-col>
            <v-col cols="6" class="col-pannel">
              <div class="label-data" style="padding-left: 12px;">Active users in last 5 minutes</div>
              <div class="value-data" style="padding-left: 12px;">{{ realtimeOverview.total_in_5_minutes }}</div>
            </v-col>
          </v-row>
          <div class="label-data">Active users per minute</div>
          <Bar :chartdata="chartdata" :options="options" :height="226" />
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="col-pannel" style="min-height: 40px;">
        <v-card class="pa-3">
          <div class="label-data">Top Countries</div>

          <div
            v-for="(country, index) in mergedCountries"
            :key="country.code || index"
            style="display: flex; gap: 24px; align-items: center; margin-top: 12px;"
          >
            <template v-if="country.flag">
              <img
                :src="country.flag"
                :alt="country.countryName"
                style="width: 50px; height: auto; border: 1px solid #cccccc"
              />
            </template>
            <template v-else>
              <div style="width: 60px; display: flex; align-items: center; justify-content: center;">
                <v-icon color="grey" style="font-size: 32px;">mdi-earth</v-icon>
              </div>
            </template>
            <div
              style="font-weight: bold; width: 100%; display: flex; align-items: center; justify-content: space-between;"
            >
              <p style="margin-bottom: 0px;">{{ country.countryName }}</p>
              <p style="margin-bottom: 0px; padding-right: 10px;">
                {{ country.doc_count }}
              </p>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- <v-row>
      <v-col cols="12" md="6" class="col-pannel">
        <v-card class="pa-3">
          <div class="label-data">Page View</div>
          <div class="value-data">{{ pageView }}</div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" class="col-pannel">
        <v-card class="pa-3">
          <div class="label-data">Vistors</div>
          <div class="value-data">{{ visitors }}</div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" class="col-pannel">
        <v-card class="pa-3">
          <div class="label-data">ATC</div>
          <div class="value-data">{{ atc }}</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" class="col-pannel">
        <v-card class="pa-3">
          <div class="label-data">Reached Checkout</div>
          <div class="value-data">{{ reachedCheckout }}</div>
        </v-card>
      </v-col>
      <v-col cols="12" class="col-pannel">
        <v-card class="pa-3">
          <div class="label-data">Session Converted</div>
          <div class="value-data">{{ sessionConverted }}</div>
        </v-card>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
import STORAGE_NAME from '@/const/storage';
import currency from '@/helpers/currency';
import moment from 'moment';
import { mapGetters } from 'vuex';
import Bar from '@/components/chart/Bar';
export default {
  components: { Bar },
  props: {
    dateRange: {
      from: Date,
      to: Date,
    },
    stores: Array,
    timezone: String,
    topCountry: {
      type: Object,
      default: () => ({ country: '', count: 0 }),
    },
    countryKeys: Array,
    lastRefreshTs: {
      type: [Number, String],
      default: null,
    },
    refreshIntervalMs: {
      type: Number,
      default: 15000,
    },
  },
  data() {
    return {
      pageView: 0,
      atc: 0,
      filter: {
        page: 1,
      },
      reachedCheckout: 0,
      sessionConverted: 0,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                min: 1,
                max: 20,
                stepSize: 5,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                autoSkip: true,
                maxTicksLimit: 7,
                minRotation: 0,
                maxRotation: 0,
              },
              scaleLabel: {
                display: true,
                labelString: 'Time',
              },
            },
          ],
        },
      },
      chartdata: {
        labels: Array.from({ length: 31 }, (_, i) => `-${30 - i} min`),
        datasets: [
          {
            label: 'Active users',
            data: [],
            backgroundColor: '#101F4A',
          },
        ],
      },
      currentTime: new Date(),
      timer: null,
      mergedCountries: [],
      // countdown (fallback internal)
      countdownDuration: 15, // seconds
      countdownStartTs: null,
      rafId: null,
      remainingSeconds: 15,
      strokeDashoffset: 0,
      circleCircumference: 2 * Math.PI * 26,
      // when parent-controlled
      parentTickIntervalId: null,
    };
  },
  computed: {
    ...mapGetters(['chartData']),
    totalSales() {
      return this.$store.getters.totalSales;
    },
    conversionRate() {
      return this.$store.getters.conversionRate;
    },
    totalOrders() {
      return this.$store.getters.totalOrders;
    },
    visitors() {
      return this.$store.getters.visitors || 0;
    },
    realtimeOverview() {
      return this.$store.getters.realtimeOverview;
    },
    aov() {
      return this.$store.getters.aov;
    },
    formattedTime() {
      const options = {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZoneName: 'short',
      };
      return new Intl.DateTimeFormat('en-US', options).format(this.currentTime);
    },
    remainingSecondsDisplay() {
      return Math.ceil(this.remainingSeconds);
    },
  },
  watch: {
    realtimeOverview: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.per_minute) {
          const counts = newVal.per_minute.map(item => item.count);

          this.chartdata = {
            ...this.chartdata,
            datasets: [
              {
                ...this.chartdata.datasets[0],
                data: counts,
              },
            ],
          };

          const max = Math.max(...counts);
          const roundedMax = Math.ceil(max / 5) * 5; // Làm tròn lên bội số của 5

          this.options.scales.yAxes[0].ticks.max = roundedMax || 5; // fallback tránh bị 0
        }

        if (Array.isArray(newVal.by_country)) {
          const countriesRaw = newVal.by_country.map(item => {
            const countryInfo = this.countryKeys.find(c => c.code === item.key);
            return {
              ...item,
              countryName: countryInfo?.value || 'Unknown',
              flag: countryInfo?.flag || null,
            };
          });

          const knownCountries = countriesRaw.filter(c => c.countryName !== 'Unknown');
          const unknownCountries = countriesRaw.filter(c => c.countryName === 'Unknown');

          if (unknownCountries.length > 0) {
            const totalCount = unknownCountries.reduce((sum, c) => sum + (c.doc_count || 0), 0);
            knownCountries.push({
              countryName: 'Others',
              flag: null,
              doc_count: totalCount,
            });
          }

          this.mergedCountries = knownCountries;
        }
      },
    },
  },
  methods: {
    formatPrice(price) {
      return currency.priceFormat(price);
    },
    loadQueryFromCache() {
      let cacheQuery = localStorage.getItem(STORAGE_NAME.REPORT_SEARCH_QUERY);
      return cacheQuery ? JSON.parse(cacheQuery) : {};
    },
    updateQuery(query) {
      this.$router.push({
        query: query,
      });
    },
    pickedDate(dates) {
      this.dateRange = {
        from: dates.startDate,
        to: dates.endDate,
      };
      let query = this.$route.query;
      this.updateQuery({
        stores: query?.stores,
        from_time: moment(this.dateRange.from).format('YYYY-MM-DD'),
        to_time: moment(this.dateRange.to).format('YYYY-MM-DD'),
        tz: query?.tz,
        refresh: query?.refresh,
      });
      // this.cacheQuery({ startDate: this.dateRange.from, endDate: this.dateRange.to });
    },
    startCountdown() {
      // If parent provides lastRefreshTs, use parent sync instead of internal RAF loop
      if (this.lastRefreshTs) return;

      // initialize internal RAF loop
      this.countdownStartTs = performance.now();
      const radius = 26;
      const circumference = 2 * Math.PI * radius;
      this.strokeDashoffset = 0;

      const loop = now => {
        const elapsedMs = now - this.countdownStartTs;
        const elapsedSec = (elapsedMs / 1000) % this.countdownDuration;
        const remaining = this.countdownDuration - elapsedSec;
        this.remainingSeconds = remaining;

        const progress = elapsedSec / this.countdownDuration; // 0..1
        const offset = circumference * progress;
        this.strokeDashoffset = offset;

        if (elapsedMs >= this.countdownDuration * 1000) {
          this.countdownStartTs = now;
        }

        this.rafId = requestAnimationFrame(loop);
      };

      this.$nextTick(() => {
        if (this.rafId) cancelAnimationFrame(this.rafId);
        this.countdownStartTs = performance.now();
        this.rafId = requestAnimationFrame(loop);
      });
    },
    stopCountdown() {
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
      if (this.parentTickIntervalId) {
        clearInterval(this.parentTickIntervalId);
        this.parentTickIntervalId = null;
      }
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      this.currentTime = new Date();
    }, 1000);
    // if parent controls refresh, sync to parent; otherwise start internal countdown
    if (this.lastRefreshTs) {
      // tick every 200ms to update ring smoothly
      const tick = () => {
        const now = Date.now();
        const interval = this.refreshIntervalMs || this.countdownDuration * 1000;
        const elapsed = now - Number(this.lastRefreshTs);
        const remainder = interval - (elapsed % interval);
        this.remainingSeconds = remainder / 1000;
        const progress = (interval - remainder) / interval; // 0..1
        this.strokeDashoffset = this.circleCircumference * progress;
      };

      tick();
      this.parentTickIntervalId = setInterval(tick, 200);
    } else {
      this.startCountdown();
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.stopCountdown();
  },
};
</script>

<style scoped>
.pannel-container {
  position: relative;
  width: 500px;
  top: 30px;
  z-index: 1;
  padding: 0 16px;
}
@media (max-width: 1279px) {
  .pannel-container {
    width: 100%;
    overflow: hidden;
  }
}
.label-data {
  color: #171725;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.1px;
}
.value-data {
  color: #171725;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.117px;
}
.col-pannel {
  padding: 4px !important;
}

.v-card {
  border: 1px solid #c9c9c9;
}

.pannel-header {
  display: flex;
  align-items: center;
  gap: 16px;
}

.countdown {
  width: 64px;
  height: 64px;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.countdown-svg {
  width: 64px;
  height: 64px;
  display: block;
}

.countdown-label {
  position: absolute;
  font-weight: 600;
  color: #171725;
  font-size: 14px;
  pointer-events: none;
}
</style>
